import React, { useState, useEffect, useRef } from 'react';
import { responsive, rutas } from '../../../resources/constantes.json';
import { motion } from 'framer-motion';
import styled from 'styled-components/macro';
import { useIsDesktop } from '../../../hooks/useMediaQuery';
import useIni from '../../../hooks/useIni';
import Cargo from 'svg/Cargo';

export const ProtectedImage = ({ imageUrl, color }) => {
  const [imageSrc, setImageSrc] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const username = 'colombia23';
    const password = 'MazamorraMazamorra23';
    const base64Credentials = btoa(`${username}:${password}`);
    fetch(imageUrl, {
      method: 'GET',
      headers: {
        Authorization: `Basic ${base64Credentials}`,
      },
    })
      .then(response => {
        if (response.ok) {
          return response.blob();
        } else {
          throw new Error('Authentication failed or image not found.');
        }
      })
      .then(imageBlob => {
        const imageSrc = URL.createObjectURL(imageBlob);
        setImageSrc(imageSrc);
      })
      .catch(error => {
        setError(error.message);
      });
  }, [imageUrl]);
  return (
    <>
      {error || !imageSrc ? (
        <div
          style={{
            backgroundColor: `${color}`,
            height: '32px',
            aspectRatio: '2/1',
          }}
        />
      ) : (
        <img src={imageSrc} alt="PartyImg" />
      )}
    </>
  );
};

const CustomTooltip = ({
  color,
  show,
  name,
  value,
  cargos,
  pieRef,
  bottomText,
  codigoPartido,
}) => {
  const ref = useRef(null);
  const isDesktop = useIsDesktop();
  const { showCurules } = useIni();
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const [partyIconNotFoundList, setPartyIconNotFoundList] = useState([]);
  useEffect(() => {
    if (isDesktop) {
      const trackMouseMovement = e => {
        setPosition({
          top: e.pageY - ref.current?.offsetHeight - 10,
          left: e.pageX - ref.current?.offsetWidth - 10,
        });
      };
      window.addEventListener('mousemove', trackMouseMovement);
      return () => window.removeEventListener('mousemove', trackMouseMovement);
    }
  }, [isDesktop]);
  useEffect(() => {
    const parentElement = ref.current.offsetParent;
    const fatherOffsetTop = parentElement.offsetHeight / 2;
    const fatherOffsetLeft = parentElement.offsetWidth / 2;
    const childOffsetTop = ref.current.offsetHeight / 2;
    const childOffsetLeft = ref.current.offsetWidth / 2;
    setPosition({
      top: fatherOffsetTop - childOffsetTop,
      left: fatherOffsetLeft - childOffsetLeft,
    });
  }, []);
  return (
    <Tooltip
      ref={ref}
      isDesktop={isDesktop}
      animate={{
        scale: show ? 1 : 0,
      }}
      style={{
        top: position.top,
        left: position.left,
      }}
      initial={{
        scale: 0,
      }}
    >
      <div
        css={`
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 10px;
          overflow: hidden;
        `}
      >
        {partyIconNotFoundList.includes(codigoPartido) ? (
          <div
            style={{
              backgroundColor: `${color}`,
              height: '90%',
              aspectRatio: '5/3',
            }}
          />
        ) : (
          <>
            {/* <div /> */}
            <img
              src={`${rutas.logo}${codigoPartido}.png`}
              width={isDesktop ? 180 : 90}
              css={`
                max-width: 100%;
              `}
              alt="party-logo"
              onError={() =>
                setPartyIconNotFoundList(previousList => [
                  ...previousList,
                  codigoPartido,
                ])
              }
            />
          </>
        )}
      </div>
      {/* <DivisionLine className="my-2" /> */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-evenly',
          alignItems: 'center',
          borderTop: '2px',
          borderColor: 'silver',
          borderStyle: 'solid',
        }}
      >
        {/* <UserOutlineIcon className="h-5 w-5" /> */}
        <h1
          style={{
            display: 'block',
            fontWeight: 700,
            fontSize: '2rem',
            color: '#77c1f9',
          }}
        >
          {showCurules ? (
            <>
              {cargos}
              <span>
                <Cargo />
              </span>
            </>
          ) : (
            <>{value}%</>
          )}
        </h1>
      </div>
      {/* <p className="self-center">{bottomText}</p> */}
      {/* <Union className="absolute -bottom-3.5 left-0 right-0 m-auto w-3" /> */}
    </Tooltip>
  );
};

const Tooltip = styled(motion.div)`
  position: absolute;
  display: grid;
  grid-template-rows: ${({ isDesktop }) => (isDesktop ? '110' : '60')}px auto;
  padding: 10px;
  min-height: 60px;
  background-color: white;
  color: #0c51a3;
  height: ${({ isDesktop }) => (isDesktop ? '150px' : '100px')};
  width: ${({ isDesktop }) => (isDesktop ? '200px' : '100px')};
  border-radius: 8px;
  pointer-events: none;
  z-index: 1;
  @media (min-width: ${responsive.tablet + 1}px) {
    z-index: 1500;
  }
`;

export default CustomTooltip;
